"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var useQuery_1 = require("./useQuery");
Object.defineProperty(exports, "useQuery", { enumerable: true, get: function () { return useQuery_1.default; } });
//# sourceMappingURL=index.js.map